import React from 'react'

import PlacementShowcase from '../Components/PlacementShowcase'

const Placement = () => {
  return (
    <div>
        <div className="review-banner" >
        <div className="about-banner-overlay" >
          <h1 className="about-banner-text">PLACEMENTS</h1>
        </div>
      </div>
       <PlacementShowcase />
    
   </div>

  )
}

export default Placement; 

// hdfydfsh hduhbjtujkdfuyidjfhyuidsja fjkdsfuyiu fkdhsfjkads ufyuis hfjkhdfjk udfyuidy  fhjhdfjk yfuidy dhfjkhfjk